









































































import { Component, Vue } from 'vue-property-decorator';
import MeasurementManager from '@/lib/measurementManager';
import FileSaver from 'file-saver';
import { Measurement } from '../lib/measurement';
import CSVPublisher from '@/lib/csvPublisher';
import GoogleDrive from '@/lib/GoogleDrive';
import moment from 'moment';

/* tslint:disable:no-console */

@Component({})
export default class Home extends Vue {
  private items: any = [];
  private manager: MeasurementManager;
  private canShare: boolean = !!navigator.share;

  private googleDrive: GoogleDrive;
  private googleDialog: boolean = false;
  private googleSignedIn: boolean = false;

  public constructor() {
    super();
    this.manager = new MeasurementManager();
    this.googleDrive = new GoogleDrive('SenTiLab');
  }

  public mounted() {
    this.manager.getAllMeasurements()
    .then((measurements) => {
      this.items = measurements;
    });
    this.googleDrive.on('profileUpdate', (profile: any) => {
      this.googleSignedIn = !!profile;
    });
  }

  private downloadJson(measurement: Measurement) {
    FileSaver.saveAs(this.getJsonFile(measurement));
  }

  private downloadCsv(measurement: Measurement) {
    FileSaver.saveAs(this.getCsvFile(measurement));
  }

  private deleteMeasurement(index: number) {
    const measurement = this.items[index];
    this.manager.deleteMeasurement(measurement)
    .then(() => {
      this.items.splice(index, 1);
    });
  }

  private share(measurement: Measurement) {
    const filesArray = [this.getJsonFile(measurement)];
    if (navigator.canShare && navigator.canShare( { files: filesArray } )) {
      navigator.share({
        files: filesArray,
        title: 'SenTiLab measurements',
        text: 'A sample of sensor measurements captured with the SenTiLab app',
      })
      .then(() => console.log('Share was successful.'))
      .catch((error: any) => console.log('Sharing failed', error.message));
    } else {
      console.log('Your system doesn\'t support sharing files.');
    }
  }

  private getJsonFile(measurement: Measurement) {
    return new File(
      [JSON.stringify(measurement)],
      this.fileName(measurement, 'json'),
      {type: 'application/json;charset=utf-8'},
    );
  }

  private getCsvFile(measurement: Measurement) {
    const publisher = new CSVPublisher(measurement);
    const csv = publisher.toCSV();

    return new File(
      [csv],
      this.fileName(measurement, 'csv'),
      {type: 'text/csv;charset=utf-8'},
    );
  }

  private uploadGoogleDrive(measurement: Measurement, index: number) {
    const name = this.fileName(measurement, 'csv');
    this.googleDrive.uploadSenTiLabFile(
      name,
      this.getCsvFile(measurement),
    ).then( (id) => {
      if (this.$store.getters.settings.g_drive.deleteAfterUpload) {
        this.deleteMeasurement(index);
        console.log(`deleting measurement (id: ${id})`);
      }
    }).catch((error) => {
      this.googleDialog = true;
      console.log('could not upload to Google Drive: ' + error);
    });
  }

  private fileName(measurement: Measurement, extension: string) {
    const prefix = 'SenTiLab';
    const exercise = measurement.exercise;
    const timestamp = this.prettyTimestamp(measurement);
    return `${prefix}-${exercise}-${timestamp}.${extension}`;
  }

  private prettyName(measurement: Measurement) {
    const exercise = measurement.exercise;
    const timestamp = this.prettyTimestamp(measurement);
    return `${exercise} - ${timestamp}`;
  }

  private prettyTimestamp(measurement: Measurement) {
    const timestamp = moment(measurement.timestamp).format('dddd D MMMM YYYY HH:mm:ss');
    return timestamp;
  }
}
